module.exports = __webpack_public_path__ + "img/flat_adhesive_box1.663fedda.png";